export const infoDeafaultData = [
  "Creating, experimenting, building the future of Web3. Collections live here.",
  "A profile built on simplicity: collections, ideas, and the freedom to create.",
  "SimpleNFT: where your journey to digital legacy begins.",
  "Keeping pace with the future. NFTs, SBTs, and creative freedom — it all starts here.",
  "Here, collections are born to live forever on the blockchain.",
  "While you're reading this, someone is already minting my next collection.",
  "Welcome! Browse, choose, and become part of my ideas.",
  "Collect my NFTs — unlock secret achievements (maybe)!",
  "Warning: Minting my NFTs may cause addiction to awesome.",
  "Every mint is a critical hit. Join the adventure!",
  "One small mint for you, one giant leap for Web3!",
  "Mint wisely. Legendary drops might be hidden here.",
  "Mint first, ask questions later.",
  "Just another degenerate making NFTs. You're welcome.",
  "Building the future one bad idea at a time (or maybe genius ideas).",
  "SBTs so strong even Vitalik would be proud.",
  "Stay calm and keep minting.",
];
